var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcRecord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Document"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3,12 C 3,7.032 7.031,3 12,3 C 16.968,3 21,7.032 21,12 C 21,16.969 16.968,21 12,21 C 7.031,21 3,16.969 3,12 Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12,4 C 16.416,4 20,7.584 20,12 C 20,16.416 16.416,20 12,20 C 7.584,20 4,16.416 4,12 C 4,7.584 7.584,4 12,4 Z",
    fill: "#ff7b5f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRecord);
export default __webpack_public_path__ + "static/media/ic_record.0a74a3d169d56faa03efefaba9097d50.svg";
export { ForwardRef as ReactComponent };